import Icon from '../components/Icon.vue'

Icon.register({
  'tint-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M633.8 458.1c7 5.4 8.2 15.5 2.8 22.5l-19.6 25.3c-5.4 7-15.5 8.2-22.5 2.8l-588.4-454.7c-7-5.4-8.2-15.5-2.8-22.5l19.6-25.3c5.4-7 15.5-8.2 22.5-2.8l186.8 144.4c21.6-33.7 43-73.3 58.5-125.7 9-30.1 50.5-28.8 58.4 0 47 158.5 146.8 200.1 146.8 311.8 0 5.7-0.5 11.3-1 16.9zM144 333.9c0-29.8 7.3-54.6 18.7-78.1l273.7 211.5c-31 27.7-71.7 44.7-116.4 44.7-97.3 0-176-79.7-176-178.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tint-slash.js
// module id = 2010
// module chunks = 0